import React from 'react';
import { CircularProgress } from 'src/components';
/**
 * @description DashboardLoading component is used to display the loading spinner in the admin dashboard
 * @returns DashboardLoading component
 */
const DashboardLoading = () => {
  return (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <CircularProgress color="neutral" size="md" />
    </div>
  );
};

export default DashboardLoading;
